import React, { useEffect, useState } from "react";
import { Alaap_dev, CMS_maati } from "urlconfig";
import { OliveProjectGeometry } from "./OliveProjectGeometry";
import { Card, CardBody, CardHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";

export const OliveFarmerDetails = ({ labelData, selectedFarmer, language }) => {
  const [FarmData, setFarmData] = useState([]);
  const [FarmLabel, setFarmLabel] = useState([]);
  // console.log("selectedFarmer",selectedFarmer)
  useEffect(() => {
    if(selectedFarmer?.documentId){
    fetch(
      `${Alaap_dev}/api/alaap-farm-crop-produce-details?filters[respondent_id]=${selectedFarmer?.documentId}`
    )
      // qay0zdzqk7lr67i3pxa5yh8o`
      // t6ilx6ktzvmeq3bkek5l0rmo`)
      //   ud5pkmxxc28wls5pullcrfj1`)
      .then((res) => res.json())
      .then((data) => {
        // console.log("detail view", data?.data);
        setFarmData(data?.data[0]);
        //   ${selectedFarmer?.documentId}`
      });
    }
  }, [selectedFarmer]);
  useEffect(() => {
    let filteredData = [];
    fetch(`${Alaap_dev}/api/alaap-ui-schemas?filters[form_name]=farm_crop_produce_info`)
      .then((res) => res.json())
      .then((data) => {
        setFarmLabel(data?.data);
        if (language === "pt-PT")
          filteredData = data?.data?.find((item) => item.language === "pt");
        else filteredData = data?.data?.find((item) => item.language === "en");
        setFarmLabel(filteredData?.labels?.form_data?.components || []);

        //   ${selectedFarmer?.documentId}`
      });
  }, [language]);
  const getLabel = (key) => {
    const found = FarmLabel?.find((item) => item.key === key);
    return found?.label || key;
  };
  // console.log("FarmData",FarmData)
  const rows = [
    { key: "crop_list", value: FarmData?.farm_crop_produce_info?.crop_list },
    { key: "crop_group", value: FarmData?.farm_crop_produce_info?.crop_group },
    {
      key: "seed_type",
      value: FarmData?.farm_crop_produce_info?.seed_type?.join(", "),
    },
    {
      key: "crop_session",
      value: FarmData?.farm_crop_produce_info?.crop_session?.join(", "),
    },
    {
      key: "crop_hectares",
      value: FarmData?.farm_crop_produce_info?.crop_hectares,
    },
    {
      key: "irrigation_type",
      value: FarmData?.farm_crop_produce_info?.irrigation_type?.join(", "),
    },
    {
      key: "land_preparation_method",
      value:
        FarmData?.farm_crop_produce_info?.land_preparation_method?.join(", "),
    },
    {
      key: "weeding_method_used",
      value:
        FarmData?.farm_crop_produce_info?.weeding_method_used?.join(", "),
    },
  ];

  return (
    <div className="row">
      <div className="col-md-7">
        {/* <Card>
          <CardHeader className="bg-orange-500 text-white font-bold text-lg">
            Farm Information
          </CardHeader>
          <CardBody className="p-4 bg-gray-50 overflow-y-auto" style={{height:"44vh"}}>
            {FarmData?
            <dl className="divide-y divide-gray-200">
              {FarmData?.farm_crop_produce_info?.crop_list && (
                <div className="flex flex-col md:flex-row md:items-start py-2">
                  <dt className="md:w-1/3 font-semibold text-gray-700">
                    {getLabel("crop_list")}
                  </dt>
                  <dd className="md:w-2/3 text-gray-900">
                  
                  </dd>
                </div>
              )}

              {FarmData?.farm_crop_produce_info?.crop_group && (
                <div className="flex flex-col md:flex-row md:items-start py-2 bg-white md:bg-gray-50">
                  <dt className="md:w-1/3 font-semibold text-gray-700">
                    {getLabel("crop_group")}
                  </dt>
                  <dd className="md:w-2/3 text-gray-900">
                    {FarmData.farm_crop_produce_info.crop_group}
                  </dd>
                </div>
              )}

              {FarmData?.farm_crop_produce_info?.seed_type?.length > 0 && (
                <div className="flex flex-col md:flex-row md:items-start py-2">
                  <dt className="md:w-1/3 font-semibold text-gray-700">
                    {getLabel("seed_type")}
                  </dt>
                  <dd className="md:w-2/3 text-gray-900">
                    {FarmData.farm_crop_produce_info.seed_type.join(", ")}
                  </dd>
                </div>
              )}

              {FarmData?.farm_crop_produce_info?.crop_session?.length > 0 && (
                <div className="flex flex-col md:flex-row md:items-start py-2 bg-white md:bg-gray-50">
                  <dt className="md:w-1/3 font-semibold text-gray-700">
                    {getLabel("crop_session")}
                  </dt>
                  <dd className="md:w-2/3 text-gray-900">
                    {FarmData.farm_crop_produce_info.crop_session.join(", ")}
                  </dd>
                </div>
              )}

              {FarmData?.farm_crop_produce_info?.crop_hectares && (
                <div className="flex flex-col md:flex-row md:items-start py-2">
                  <dt className="md:w-1/3 font-semibold text-gray-700">
                    {getLabel("crop_hectares")}
                  </dt>
                  <dd className="md:w-2/3 text-gray-900">
                    {FarmData.farm_crop_produce_info.crop_hectares}
                  </dd>
                </div>
              )}

              {FarmData?.farm_crop_produce_info?.irrigation_type?.length >
                0 && (
                <div className="flex flex-col md:flex-row md:items-start py-2 bg-white md:bg-gray-50">
                  <dt className="md:w-1/3 font-semibold text-gray-700">
                    {getLabel("irrigation_type")}
                  </dt>
                  <dd className="md:w-2/3 text-gray-900">
                    {FarmData.farm_crop_produce_info.irrigation_type.join(", ")}
                  </dd>
                </div>
              )}

              {FarmData?.farm_crop_produce_info?.land_preparation_method
                ?.length > 0 && (
                <div className="flex flex-col md:flex-row md:items-start py-2">
                  <dt className="md:w-1/3 font-semibold text-gray-700">
                    {getLabel("land_preparation_method")}
                  </dt>
                  <dd className="md:w-2/3 text-gray-900">
                    {FarmData.farm_crop_produce_info.land_preparation_method.join(
                      ", "
                    )}
                  </dd>
                </div>
              )}

              {FarmData?.farm_crop_produce_info?.weeding_method_used?.length >
                0 && (
                <div className="flex flex-col md:flex-row md:items-start py-2 bg-white md:bg-gray-50">
                  <dt className="md:w-1/3 font-semibold text-gray-700">
                    {getLabel("weeding_method_used")}
                  </dt>
                  <dd className="md:w-2/3 text-gray-900">
                    {FarmData.farm_crop_produce_info.weeding_method_used.join(
                      ", "
                    )}
                  </dd>
                </div>
              )}
            </dl>
            :
            <div className="text-center mt-5"> No Data Available</div>
            }
          </CardBody>
        </Card> */}
        <Card>
      <CardHeader className="">
        Farm Information
      </CardHeader>

      <CardBody
       className="p-4 bg-gray-50 overflow-y-auto" style={{height:"44vh"}}
      >
        {FarmData ? (
          <dl className="divide-y divide-gray-200">
            {rows?.map(
              (row, index) =>
                row.value && (
                 
                   <div
                    key={index}
                    className={` mb-1 
                    ${index % 2 === 0 ? "bg-white" : "bg-gray-100"}`}
                  >
                   <div className="py-2">
                  <dt className="font-semibold">
                     {getLabel(row.key)}
                  </dt>
                  <dd className="text-black mt-1">
                    <FontAwesomeIcon
                        icon={faAngleRight}
                        className="text-warning text-sm me-2"
                      />{row.value}
                  </dd>
                </div>
                </div>
                )
            )}
          </dl>
        ) : (
          <div className="text-center mt-5">No Data Available</div>
        )}
      </CardBody>
    </Card>
      </div>
      <div className="col-md-5">
        <Card>
          <CardHeader>{getLabel("geom")}</CardHeader>
          <CardBody className="p-2">
            <OliveProjectGeometry FarmData={FarmData} />
          </CardBody>
        </Card>
      </div>
    </div>
  );
};
